import React from "react";
import Col from "react-bootstrap/Col";

/**
 * Project Display Component
 * Displays project/client/sprint information when not in edit mode
 */
const ProjectDisplay = ({
  project,
  sprint,
  client,
  currentTextCount,
  onClick,
  isMobile = false,
}) => {
  const projectName = project?.project_name || "";
  const sprintName = sprint?.sprint_name || "";
  const clientName = client || "";

  return (
    <Col className="cursor" onClick={onClick}>
      <span
        className={`tooltip-tracker ${currentTextCount(
          projectName,
          sprintName,
          clientName
        ) < 21 ? "small" : "large"}`}
      >
        {projectName}
        {`${sprintName ? ` - ${sprintName}` : ""}`}
        <div className="project-name-tracker">{clientName}</div>
      </span>
      <span
        className={`project-tracker-inner ${isMobile ? "" : "11"} ${currentTextCount(
          projectName,
          sprintName,
          clientName
        ) < 21 ? "small" : "large"}`}
        style={{
          display: "inline-block",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          height: "22px",
          ...(isMobile && { maxWidth: "140px" }),
        }}
      >
        {projectName}
        {`${sprintName ? ` - ${sprintName}` : ""}`}
        <div className="project-name-tracker">{clientName}</div>
      </span>
    </Col>
  );
};

export default ProjectDisplay;
